import { useState, useEffect } from "react";
import { Grid } from "@mui/material";

import PropTypes from "prop-types";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDDatePicker from "components/MDDatePicker";
import MDButton from "components/MDButton";

function Query({ onQuery }) {
  const startDateState = useState("");
  const endDateState = useState("");
  const [disableStartDate, setDisabledStartDate] = useState([]);
  const [disableEndDate, setDisabledEndDate] = useState([]);

  const [startDate] = startDateState;
  const [endDate] = endDateState;

  useEffect(() => {
    setDisabledStartDate([
      {
        from: endDate,
        to: "2028-12-31",
      },
    ]);
    setDisabledEndDate([
      {
        from: "2020-01-01",
        to: startDate,
      },
    ]);
  }, [startDate, endDate]);

  const handleQuery = () => {
    onQuery({
      startDate,
      endDate,
    });
  };
  return (
    <MDBox pb={1} px={2} pt={2}>
      <Grid container justifyContent="space-between" alignItems="center" rowSpacing={2}>
        <Grid item xs={12} md={2}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            佣金记录
          </MDTypography>
        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid
              item
              xs={4.8}
              sm={5}
              md={2.7}
              lg={2}
              xl={2.2}
              xxl={1.8}
              xxxl={1.5}
              xxxxl={1.3}
              xxxxxl={1.1}
            >
              <MDDatePicker
                input={{
                  label: "开始日期",
                  sx: {
                    width: "100%",
                  },
                  search: true,
                }}
                valueState={startDateState}
                value={startDate}
                options={{
                  altFormat: "Y-m-d",
                  altInput: true,
                  disable: disableStartDate,
                }}
              />
            </Grid>
            <Grid
              item
              xs={4.8}
              sm={5}
              md={2.7}
              lg={2}
              xl={2.2}
              xxl={1.8}
              xxxl={1.5}
              xxxxl={1.3}
              xxxxxl={1.1}
            >
              <MDDatePicker
                input={{
                  label: "结束日期",
                  sx: {
                    width: "100%",
                  },
                  search: true,
                }}
                valueState={endDateState}
                value={endDate}
                options={{
                  altFormat: "Y-m-d",
                  altInput: true,
                  disable: disableEndDate,
                }}
              />
            </Grid>
            <Grid item>
              <MDButton color="dark" variant="gradient" onClick={handleQuery}>
                查询
              </MDButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MDBox>
  );
}

Query.defaultProps = {
  onQuery: () => {},
};
Query.propTypes = {
  onQuery: PropTypes.func,
};
export default Query;
